(() => {
  'use strict';

  const placeRewardsInApprovedOrder = () => {
    const cards = document.querySelectorAll('.essential-wtr-rewards .essential-card');
    if (cards.length < 4 || cards[1].dataset.ksOrderAdjusted === 'true') return;

    const second = cards[1];
    const fourth = cards[3];
    const marker = document.createTextNode('');
    second.before(marker);
    fourth.before(second);
    marker.replaceWith(fourth);
    second.dataset.ksOrderAdjusted = 'true';
  };

  document.addEventListener('DOMContentLoaded', placeRewardsInApprovedOrder, { once: true });
  window.addEventListener('load', placeRewardsInApprovedOrder, { once: true });
})();
